import { ProjectHelper } from '@bimser/common';

export function PullNewNumber(projectName: string, formName: string) {
	return ProjectHelper.RunPromiseFormService({
		projectName: projectName,
		formName: formName,
		serviceName: 'CreateUniqueId',
		serviceMethod: 'get'
	});
}
